/*
const myHeartShape = new HeartShape({
  x: 50,
  y: 50,
  fill: 'black',
  stroke: engraveColor,
  strokeWidth: 3,
  width: 300,
  height: 300,
});
console.log("myHeartShape", myHeartShape);
layer.add(myHeartShape);
layer.draw();
selectNode(myHeartShape);
*/
class HeartShape extends Konva.Path {
  constructor(config) {
    super(config);

    this.className = 'HeartShape';
    this.attrs.type = "shape";

    //console.log("HeartShape config", this.attrs);
    //this.setData( generateEllipseSvgTextPath(400, 400, 200, 120, 0) );

    if (this.attrs.width == undefined) {
      this.setWidth(300);
    }

    if (this.attrs.height == undefined) {
      this.setHeight(300);
    }

    this.updatePath();

    this.setDraggable(true);
  }

  _width() {
    Konva.TextPath.prototype.width.call(this);
  }

  _height() {
    Konva.TextPath.prototype.height.call(this);
  }

}

HeartShape.prototype.getWidth = function () {
  return this.attrs.width;
};

HeartShape.prototype.setWidth = function (width) {
  this.attrs.width = parseInt(width);
  this.updatePath();
};

HeartShape.prototype.getHeight = function () {
  return this.attrs.height;
};

HeartShape.prototype.setHeight = function (height) {
  this.attrs.height = height;
  this.updatePath();
};

HeartShape.prototype.updatePath = function () {
  this.setData(this.generateSvgPath(this.getWidth(), this.getHeight()));
};

HeartShape.prototype.generateSvgPath = function(width=300, height=300) {
  const kX = width / 200;
  const kY = height / 250;
  const path = `M${100 * kX},${50 * kY} C${150 * kX},${-10 * kY} ${200 * kX},${50 * kY} ${200 * kX},${100 * kY} C${200 * kX},${150 * kY} ${150 * kX},${200 * kY} ${100 * kX},${250 * kY} C${50 * kX},${200 * kY} 0,${150 * kY} 0,${100 * kY} C0,${50 * kY} ${50 * kX},${-10 * kY} ${100 * kX},${50 * kY} Z`;
  
  return path;
}
